import { carmaCsrAuthClient } from 'src/services/instance/carmaCsrAuthClient';
import { FiltersPayloadRow } from 'src/types/CarFilters.types';

export interface SavedSearch {
  id: string;
  name: string;
  filters: FiltersPayloadRow[] | [];
  plp_slug: string;
  is_similar_to?: string | null;
  subscribed_at: string | null;
  typesense_query: string;
}

export const SAVED_SEARCH_DEFAULT_NAME = 'Saved search';

export const getSavedSearches = () =>
  carmaCsrAuthClient.get<{ searches: SavedSearch[] }>(`me/save-searches`).then((body) => body.json());

export const createSavedSearch = (
  search: Prettify<Pick<SavedSearch, 'name' | 'filters' | 'is_similar_to' | 'plp_slug' | 'typesense_query'>>,
) => carmaCsrAuthClient.put<SavedSearch>(`me/save-searches`, { json: search }).then((body) => body.json());
